var $ = require('jquery');


const FORM_ERROR_CLASS = 'floating-label__input--invalid';

$(function() {

    let _emailSubscribeForm = $('#footerEmailSubscribeForm, #homepageEmailSubscribeForm');

    if(_emailSubscribeForm) {
        _emailSubscribeForm.keydown(function(){
            clearFormDuplicateEmailMsg($(this));
        });

        _emailSubscribeForm.submit(function(e){
            e.preventDefault();
            let noErrors = !formHasErrors($());
            if(noErrors) {
                clearFormDuplicateEmailMsg($(this));
                let _emailSubscribeComponent = $(this).find('.js-newsletter-email-subscribe-component');
                sendSubscribeEmail(_emailSubscribeComponent);
            }
        });
    }

});

function sendSubscribeEmail(subscribeComponent) {
    let emailEl = $(subscribeComponent).find('.js-newsletter-email-subscribe');
    if(emailEl) {
        let email = emailEl.val();

        let dataObject = {
            email: email
        };
        let data = $.param(dataObject);
        $.ajax({
            type: 'POST',
            url: '/account/ajax/signUpForNewsLetter',
            data: data,
            success: function (rtn) {
                if (rtn.success) {
                    showSuccessEmailSubscribeMsg(subscribeComponent);
                    if (typeof window.PAGE_TRACK_A_MODULE !== 'undefined' && $.isFunction(window.PAGE_TRACK_A_MODULE.insertEventTrack)) {
                        window.PAGE_TRACK_A_MODULE.insertEventTrack('news_letter_in_footer', 'subscribe', 'email:' + email);
                    }
                    if(typeof(crdl) != 'undefined' && crdl != null) {
                        crdl('contact', { email: email }, {'channels': { 'email': {'subscribeStatus': 'subscribed'} }});
                    }
                } else if (rtn.duplicate) {
                    showDuplicateEmailSubscribeMsg(subscribeComponent);
                } else {
                    console.log('Invalid Email');
                }
            }
        });
    }
}

function clearFormDuplicateEmailMsg(form) {
    let _dupEmailSubscribeError = form.find('.js-newsletter-email-subscribe-error');
    if(_dupEmailSubscribeError) _dupEmailSubscribeError.remove();
}

function formHasErrors(form){
    return form.find('input:visible.' + FORM_ERROR_CLASS).length > 0 ||
        form.find('select:visible option:selected').is(':disabled');
}

function showSuccessEmailSubscribeMsg(subscribeComponent){
    const successEl = $('<p class="u-error">Woohoo! You\'re officially on the superdown list!</p>');
    successEl.insertAfter(subscribeComponent);
    subscribeComponent.remove();
}

function showDuplicateEmailSubscribeMsg(subscribeComponent){
    const duplicateEl = $('<p class="js-newsletter-email-subscribe-error u-error">Oops! Looks like you\'re already signed up!</p>');
    duplicateEl.insertAfter(subscribeComponent);
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/index.js